module.exports = __webpack_public_path__ + "front/img/share.14dad48b.jpg";